import { plural } from '@cian/utils';
import { connect } from 'react-redux';

import { IAppState } from '../../../../common/state';
import { getUniqueTotalCountTitle } from '../../../../utils/getUniqueTotalCountTitle';
import { numberToPrettyString } from '../../../../utils/numberToPrettyString';
import { SummaryHeader } from '../../../components/Summary';
import { getOffersCount } from '../utils/selectors';

export function mapStateToProps(state: IAppState) {
  const offersCount = getOffersCount(state);

  /**
   * @todo Прикрутить логику получения данных с бэка в рамках задачи CD-112615
   * @description Данный функционал появился в задаче CD-110067, был удалён в задаче CD-110558
   */
  const totalCountTitle = getUniqueTotalCountTitle(0);

  return {
    header: `Найдено ${numberToPrettyString(offersCount)} ${plural(offersCount, [
      'объявление',
      'объявления',
      'объявлений',
    ])}`.concat(totalCountTitle),
  };
}

export const SummaryHeaderContainer = connect(mapStateToProps)(SummaryHeader);
